import { render, staticRenderFns } from "./ReportPP.vue?vue&type=template&id=52bdaf46&"
import script from "./ReportPP.vue?vue&type=script&lang=js&"
export * from "./ReportPP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports